module.exports = __webpack_public_path__ + "img/intersect.993fa90c.svg";